export default {
    parse: {
        prelude: null,
        block() {
            return this.Block(true);
        }
    }
};
